import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { PRIMARY_CTA_URL, services } from "../data/business";

const typographicBg = ["from-ink to-[#2a2320]", "from-[#4a3430] to-ink", "from-[#6b4a3f] to-[#2a1e1a]"];

export default function Services() {
    return (
        <section
            id="servicos"
            data-testid="services-section"
            className="bg-paper py-20 sm:py-28 lg:py-36"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Eyebrow>O que fazemos</Eyebrow>
                <Reveal delay={0.1}>
                    <h2 className="mt-5 max-w-2xl font-display text-3xl font-medium uppercase leading-[1.08] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Serviços com <span className="italic text-accent">técnica e acabamento.</span>
                    </h2>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                    {services.map((s, i) => (
                        <Reveal key={s.title} delay={(i % 3) * 0.1} className="h-full">
                            <article
                                data-testid={`service-card-${i + 1}`}
                                className="group flex h-full flex-col border border-line bg-paper transition-all duration-500 hover:-translate-y-1 hover:border-accent/40"
                            >
                                {s.photo ? (
                                    <div className="overflow-hidden">
                                        <img
                                            src={s.photo}
                                            alt={`Trabalho real — ${s.title}`}
                                            loading="lazy"
                                            className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                                        />
                                    </div>
                                ) : (
                                    <div
                                        className={`flex aspect-[4/3] items-center justify-center bg-gradient-to-br ${typographicBg[i % 3]} p-6`}
                                    >
                                        <p className="text-center font-display text-2xl font-medium uppercase leading-tight tracking-wide text-paper/90 sm:text-3xl">
                                            {s.title}
                                        </p>
                                    </div>
                                )}
                                <div className="flex flex-1 flex-col p-6 sm:p-7">
                                    <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-accent">
                                        0{i + 1} — Serviço
                                    </span>
                                    <h3 className="mt-3 font-display text-2xl font-semibold text-ink">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-soft">
                                        {s.description}
                                    </p>
                                    <a
                                        href={PRIMARY_CTA_URL}
                                        data-testid={`service-cta-${i + 1}`}
                                        className="mt-6 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-ink transition-colors duration-300 hover:text-accent"
                                    >
                                        Conhecer o serviço
                                        <ArrowRight
                                            size={14}
                                            className="transition-transform duration-300 group-hover:translate-x-1"
                                        />
                                    </a>
                                </div>
                            </article>
                        </Reveal>
                    ))}

                    <Reveal delay={0.2} className="h-full">
                        <article className="flex h-full flex-col justify-between bg-ink p-8 text-paper">
                            <p className="font-display text-3xl font-medium uppercase leading-tight">
                                Cada cliente,
                                <br />
                                <span className="italic text-accent">um acabamento único.</span>
                            </p>
                            <div className="mt-8">
                                <p className="text-sm leading-relaxed text-paper/60">
                                    O serviço ideal para você é definido na conversa — de
                                    acordo com suas unhas, sua rotina e o resultado que
                                    você quer.
                                </p>
                                <a
                                    href={PRIMARY_CTA_URL}
                                    data-testid="service-cta-consult"
                                    className="mt-6 inline-flex items-center gap-2 border border-paper/30 px-5 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:border-accent hover:text-accent"
                                >
                                    Agendar meu horário
                                    <ArrowRight size={14} />
                                </a>
                            </div>
                        </article>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
